import React from 'react'
import { useStyles } from '../alerts/styles'
import { Box, Stack } from '@mui/material'
import GlobalNotificationHeader from './GlobalNotificationHeader/GlobalNotificationHeader'
import GlobalNotificationTabView from './GlobalNotificationTabView/GlobalNotificationTabView'
import { ExtraSmallButton } from '../custom'
import ClearIcon from '../../assets/icons/ClearIcon'

type Props = {
    onClose?: () => void
}

const GlobalNotification = ({ onClose }: Props) => {
    const { classes } = useStyles()
    return (
        <Box className={classes.alertContainer}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ flexShrink: 0 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <GlobalNotificationHeader />
                </Box>
                {onClose ? (
                    <ExtraSmallButton
                        sx={{ height: '34px', width: '34px', flexShrink: 0 }}
                        onClick={onClose}
                        color="inherit"
                        aria-label="Close notifications"
                    >
                        <ClearIcon sx={{ fontSize: '24px' }} />
                    </ExtraSmallButton>
                ) : null}
            </Stack>
            <GlobalNotificationTabView />
        </Box>
    )
}
export default GlobalNotification
